<div id="panel" class="panel" style="height: fit-content" (keydown.escape)="close()">
  <input
    style="width: calc(100% - 10px)"
    dir="rtl"
    size="50"
    value=""
    type="text"
    [placeholder]="'ClientApp.FrontOffice.Parties.Map.TypeAddress' | translate"
    required
    id="address"
    (keypress)="onAddressKeyPress($event)" />
  <button id="search" style="margin-top: 10px; white-space: nowrap; padding: 5px 10px" (click)="geocoding()">
    {{ "ClientApp.FrontOffice.Parties.Map.SearchForLatitudeAndLongitude" | translate }}
  </button>

  <button id="openModalBtn" hidden="hidden">{{ "ClientApp.FrontOffice.Parties.Map.Guide" | translate }}</button>
  <a href="#" onclick="openModalBtn.click()">{{ "ClientApp.FrontOffice.Parties.Map.Guide" | translate }}</a>
</div>

<div
  id="map"
  style="
    width: 80%;
    height: 80%;
    position: absolute;
    z-index: 1;
    display: block;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgb(244, 243, 239);
    outline: none;
    border-radius: 10px;
  "></div>

<div id="myModal" class="modal">
  <div class="modal-content">
    <span class="close">&times;</span>
    <div
      class="elementor-element elementor-element-466b9df elementor-widget elementor-widget-alert"
      data-id="466b9df"
      data-element_type="widget"
      data-widget_type="alert.default">
      <div class="elementor-widget-container">
        <div class="elementor-alert elementor-alert-info" role="alert">
          <span class="elementor-alert-title"
            >{{ "ClientApp.FrontOffice.Parties.Map.AccuratePointsCurrentVersion" | translate }} geocoding
            {{ "ClientApp.FrontOffice.Parties.Map.ObserveFollowingPointsPossible" | translate }} :</span
          >
          <span class="elementor-alert-description">
            <div class="alert alert-info" role="alert">
              <ul style="text-align: right; list-style: persian; margin-top: 15px; margin-right: 25px">
                <li>
                  {{ "ClientApp.FrontOffice.Parties.Map.PossibleOrderAddressComponentsFollows" | translate }}:
                  <br />
                  {{ "ClientApp.FrontOffice.Parties.Map.Province" | translate }} + {{ "ClientApp.FrontOffice.Parties.Map.City" | translate }} /
                  {{ "ClientApp.FrontOffice.Parties.Map.Village" | translate }} + {{ "ClientApp.FrontOffice.Parties.Map.Ground" | translate }} +
                  {{ "ClientApp.FrontOffice.Parties.Map.Street" | translate }} + {{ "ClientApp.FrontOffice.Parties.Map.Alley" | translate }} +
                  {{ "ClientApp.FrontOffice.Parties.Map.Plaque" | translate }}
                  <br />
                  {{ "ClientApp.FrontOffice.Parties.Map.Tip" | translate }}:
                  {{ "ClientApp.FrontOffice.Parties.Map.LicensePlateNumberCities" | translate }}
                </li>
                <li>
                  {{ "ClientApp.FrontOffice.Parties.Map.BeDelimitAddress" | translate }} space
                  {{ "ClientApp.FrontOffice.Parties.Map.BeSeparated" | translate }}
                  <br />
                  {{ "ClientApp.FrontOffice.Parties.Map.Example" | translate }}:
                  <span style="font-weight: 700; color: red">{{ "ClientApp.FrontOffice.Parties.Map.Zandvakili" | translate }}</span>
                  {{ "ClientApp.FrontOffice.Parties.Map.BetterWithSeparatorForm" | translate }}
                  <span style="font-weight: 700; color: green">{{ "ClientApp.FrontOffice.Parties.Map.ZandVakili" | translate }}</span>
                  {{ "ClientApp.FrontOffice.Parties.Map.BeSent" | translate }}
                </li>
                <li>
                  {{ "ClientApp.FrontOffice.Parties.Map.SpecificationsRelated" | translate }} poi
                  {{ "ClientApp.FrontOffice.Parties.Map.NamesOfRemovedAddressPossible" | translate }}
                  <br />
                  {{ "ClientApp.FrontOffice.Parties.Map.Example" | translate }}: {{ "ClientApp.FrontOffice.Parties.Map.AddressType" | translate }}
                  <span style="font-weight: 700; color: red">{{ "ClientApp.FrontOffice.Parties.Map.KameliaBuilding" | translate }}</span>
                  <br />
                  {{ "ClientApp.FrontOffice.Parties.Map.ChangeAddressType" | translate }}
                </li>
                <li>{{ "ClientApp.FrontOffice.Parties.Map.DestinationVillageAddress" | translate }}</li>
                <li>{{ "ClientApp.FrontOffice.Parties.Map.DetermineExactCoordinatesAddress" | translate }}</li>
              </ul>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
